import * as Sentry from '@sentry/react'

export function captureException(error: Error, source?: string): void {
  Sentry.captureException(error, source ? { tags: { source } } : {})
}
